var $ = require( 'jquery' );
import 'magnific-popup';

$(document).ready(function() {
    initPopup();
});

function initPopup() {
    $('a[href="#popup"]').on('click', function(e) {
        e.preventDefault();
        const popupElem = $(this).closest('.section-content-block').find('.section-content-block__popup');
        $.magnificPopup.open({
            type: 'inline',
            items: {
                src: popupElem
              },
            removalDelay: 300,
            mainClass: 'mfp-fade',
            preloader: false,
            showCloseBtn: false,
            callbacks: {
                open: function() {
                    setTimeout( function() {
                        $('.section-content-block__popup form input[name="first-name"]').focus();
                    }, 100);
                }
            }
        });

    });

    $('.section-content-block__popup__close').on('click', function(e) {
        e.preventDefault();
        $.magnificPopup.close();
    });

    $('.section-content-block .wpcf7').on('wpcf7mailsent', function() {
        $(this).remove();
        $('.popup-thank-you').show();
        $('.section-content-block__popup__close').focus();
    });
}
